<ng-template #fieldTypeTemplate>
</ng-template>
<div class="relative w-full">
  <thk-date-range-picker
    class="w-full"
    [formControl]="formControl"
    [formlyAttributes]="field"
    [format]="props.format"
    [placeholder]="props.placeholder"
  ></thk-date-range-picker>
</div>
